export interface HttpError {
  status: number;
  body?: {
    errorCode: number;
    errorFields: string[];
  };
}

export function http(response: Response) {
  if (response.status >= 200 && response.status < 300) {
    return response.text().then(text => (text.length ? JSON.parse(text) : {}));
  }
  return response.text().then(text => {
    const error: HttpError = {
      status: response.status,
      body: text.length ? JSON.parse(text) : {},
    };
    return Promise.reject(error);
  });
}
